import { IDropDownCardMenu } from '@/models/dropdownCardMenu';

export type StartGuideTaskType = 'task' | 'feedback';

export enum EStartGuideTaskSlug {
  CUSTOMIZE_COIN = 'customize-coin',
  SELL_COINS = 'sell-coins',
  REWARD_COINS = 'reward-coins',
  WELCOME_COINS = 'welcome-coins',
  SPECIAL_COINS = 'special-coins',
  REFERRAL_PROGRAM = 'referral-program',
  SOCIAL_REWARDS = 'social-rewards',
  INVITE_CUSTOMERS = 'invite-customers',
  SUCCESS_MESSAGE = 'success-message'
}

export enum EStartGuideDiscoverMoreSlug {
  TELL_US_MORE = 'tell-us-more',
  ADD_LOCATIONS = 'add-locations',
  ADD_MEMBERS = 'add-members'
}

export interface StartGuideTask {
  slug: string;
  trigger?: string;
  imageUrl?: string;
  type: StartGuideTaskType;
  title: string;
  description: string;
  successTitle?: string;
  successDescription?: string;
  actionLabel?: string;
  completed?: boolean;
  dismissed?: boolean;
  availableFor: string[];
  videoTutorialLink?: string;
}

export interface StartGuideState {
  completedAllTasks?: boolean;
  loading?: boolean;
  preferences: StartGuidePreferences;
  tasks: StartGuideTask[];
  activePrograms: StartGuideCardActiveProgram[];
  discoverMore: StartGuideDiscoverMoreCard[];
  needHelp: StartGuideCardNeedHelp[];
  shouldShowChooseContainer?: boolean;
  homeOverview: Record<string, any>;
}

export interface StartGuidePreferences {
  expanded: boolean;
  showTipCoinMessage: boolean;
  startBy?: string;
  finished?: boolean;
}

export interface StartGuideTasksResponse {
  items: {
    preferences: StartGuidePreferences;
    tasks: StartGuideTask[];
    programs: StartGuideCardActiveProgram[];
  };
}
export interface StartGuideCardActiveProgramResponse {
  items: {
    programs: StartGuideCardActiveProgram[];
  };
}

export interface StartGuideCardActiveProgram {
  slug: string;
  title: string;
  description: string;
  link?: string;
  linkLabel?: string;
  menuLinks?: Array<IDropDownCardMenu>;
  expiredDate?: string;
  createdAt?: string;
  label?: string;
  id?: string;
}

export interface StartGuideDiscoverMoreCard {
  slug: string;
  title: string;
  description: string;
  link: string;
  linkLabel: string;
  dismissed?: boolean;
  menuLinks?: Array<IDropDownCardMenu>;
}

export interface StartGuideCardNeedHelp {
  title: string;
  description: string;
  link?: string;
}
